var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContract = function SvgContract(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.346 2 2 3.346 2 5V8H4V20H9V18H6V8H17V5C17 4.449 17.448 4 18 4C18.565 4 19 4.43497 19 5V20H21V5C21 3.35503 19.645 2 18 2H5ZM5 4H15.1719C15.0609 4.313 15 4.65 15 5V6H4V5C4 4.449 4.449 4 5 4H5ZM8 10V12H17V10H8ZM8 14V16H10V14H8ZM14 14C12.355 14 11 15.355 11 17C11 17.8764 11.3918 18.6622 12 19.2129V22.8047L14 21.5547L16 22.8047V19.2129C16.6082 18.6622 17 17.8764 17 17C17 15.355 15.645 14 14 14ZM14 16C14.5641 16 15 16.4359 15 17C15 17.5641 14.5641 18 14 18C13.4359 18 13 17.5641 13 17C13 16.4359 13.4359 16 14 16Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Contract.6ced4b0f.svg";
export { ForwardRef as ReactComponent };